import React, { useRef, useState, useEffect } from "react"
import { Pie } from "react-chartjs-2"
import { FaDownload } from "react-icons/fa"
import API from "../../api" // Assure-toi que le chemin est correct

const StatsPieChart = () => {
  const chartRef = useRef(null)
  const [data, setData] = useState({
    labels: ["Complet", "En cours", "Jamais"],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ["#4CAF50", "#FF9800", "#ff0000"],
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  })

  const options = {
    maintainAspectRatio: false,
    responsive: true,
  }
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  const handleDownload = () => {
    const chart = chartRef.current?.chartInstance
    if (!chart) return
    const base64Image = chart.toBase64Image()
    const link = document.createElement("a")
    link.href = base64Image
    link.download = "Statistique des emplois de groupes.png"
    link.click()
  }

  // 🔹 Récupération des données de l'API
  const fetchData = async () => {
    try {
      const res = await API.post("emploi/stat_emploi_grp",{annee_id})
      const resume = res.data.resume
      setData({
        labels: ["Complet", "En cours", "Jamais"],
        datasets: [
          {
            data: [resume.Complet, resume["En cours"], resume.Jamais],
            backgroundColor: ["#4CAF50", "#FF9800", "#ff0000"],
            borderColor: "#fff",
            borderWidth: 2,
          },

        ],
      })
    } catch (error) {
      console.error("❌ Erreur API :", error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ color: "#4CAF50" }}>{"Statistique des emplois de groupes"}</h3>
      <FaDownload
        onClick={handleDownload}
        style={{ cursor: "pointer", marginBottom: "10px", color: "#E91E63", fontSize: "17px" }}
      />
      <div style={{ height: "250px" }}>
        <Pie ref={chartRef} data={data} options={options} />
      </div>
    </div>
  )
}

export default StatsPieChart
